import { NgModule } from '@angular/core';
import { CarouselComponent } from './carousel.component';
import { CarouselItemComponent } from '../carousel-item/carousel-item.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  exports: [CarouselComponent, CarouselItemComponent],
  declarations: [CarouselComponent, CarouselItemComponent]
})
export class CarouselModule {
}
